<template>
  <div class="teamReservation">
    <van-sticky offset-top="1.227rem">
      <van-steps
        :active="active"
        active-color="#0B6CF9"
        @click-step="clickStep"
      >
        <van-step>填写信息</van-step>
        <van-step>提交申请</van-step>
        <van-step>等待审核</van-step>
      </van-steps>
    </van-sticky>
    <template v-if="active === 0">
      <div class="date_box">
        <div class="dates">
          <div v-for="(item, index) in dateList" :key="index" class="date_item">
            <span>{{ item.title }}</span>
            <div
              @click="
                !item.isDue && item.remainingQuantity > 0 ? onDate(index) : null
              "
              :style="{
                backgroundColor:
                  !item.isDue && item.remainingQuantity > 0
                    ? dateActive === index
                      ? '#076cfa'
                      : '#b4d3ff'
                    : '#cdcdcd',
              }"
            >
              <span>{{ item.date }}</span>
              <span>{{
                item.isClose
                  ? "闭馆日"
                  : item.remainingQuantity > 0
                  ? `余${item.remainingQuantity}`
                  : "已约满"
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="title"><span>选择场次</span></div>
        <div class="sessions" v-if="dateActive !== null">
          <div
            v-for="(item, index) in scheduleList[dateActive]"
            :key="index"
            @click="
              item.remainingQuantity > 0 && item.status === 1
                ? selectSession(index)
                : null
            "
            :class="{
              sessionsActive: sessionsActive === index,
              state: !(item.remainingQuantity > 0 && item.status === 1),
            }"
          >
            <span>{{ item.startTime + " - " + item.endTime }}</span>
            <span>{{
              item.status === 2
                ? "已截止"
                : item.remainingQuantity > 0
                ? `余${item.remainingQuantity}张`
                : "已约满"
            }}</span>
            <img
              v-show="sessionsActive === index"
              src="@/assets/images/icon4.svg"
              alt=""
            />
          </div>
        </div>
        <div class="sessions" v-else>
          <span class="tips">请先选择日期</span>
        </div>
        <div class="quantity">
          <div>
            <p>团队人数：</p>
            <van-stepper
              v-model="quantity.td"
              theme="round"
              button-size="18"
              disable-input
              :min="
                steppers.td && steppers.td.min ? steppers.td.min : undefined
              "
              :max="
                steppers.td && steppers.td.max ? steppers.td.max : undefined
              "
              default-value="0"
            />
          </div>
          <div>
            <span>{{ steppers.td && steppers.td.title }}</span>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="title title_box">
          <span>团队联系人</span>
          <div class="add_btn" @click="addPersonnel(1, 'list', 'list2')">
            添加/更换
          </div>
        </div>
        <div class="form_box" v-if="list.length">
          <div v-for="(item, index) in list" :key="index" class="item">
            <img
              src="@/assets/images/delete_p.png"
              alt=""
              @click="del(item, 'list')"
            />
            <div class="right">
              <div class="info">
                <p class="name">{{ item.name }}</p>
                <p>证件号码：{{ item.documentNumber }}</p>
                <p>手机号码：{{ item.phone }}</p>
              </div>
            </div>
          </div>
        </div>
        <p v-else class="please_select">请选择1位团队联系人</p>
      </div>
      <div class="box">
        <div class="title">
          <span>团队信息</span>
        </div>
        <div class="teamInformation">
          <div class="tips">
            <div><van-icon name="warning" />温馨提示</div>
            <p>
              请先下载模板，按要求如实填写，填好后拍照或扫描上传，支持文件格式：png、jpg、jpeg、pdf。
            </p>
          </div>
          <div class="form_box">
            <van-form
              label-width="1.733rem"
              :colon="true"
              ref="templateFile"
              class="form"
            >
              <van-field
                name="预约登记"
                label="预约登记"
                :rules="[{ required: true, message: '预约登记不能为空' }]"
              >
                <template #input>
                  <div class="upload_box">
                    <van-uploader
                      accept="image/*,.pdf"
                      v-model="templateFile"
                      :preview-image="false"
                      :after-read="afterRead"
                      :disabled="templateFile.length > 0"
                      v-show="templateFile.length <= 0"
                    >
                      <van-button icon="plus" size="small">上传文件</van-button>
                    </van-uploader>
                    <div
                      class="fileList"
                      v-for="(item, index) in templateFile"
                      :key="index"
                    >
                      <span>{{ item.file.name.split("/").at(-1) }}</span>
                      <van-icon name="cross" @click="templateFile = []" />
                    </div>
                    <div class="fileList">
                      <a :href="data.templateFileUrl" target="_blank"
                        ><span>团队参观预约登记表模板.docx</span
                        ><van-icon name="down"
                      /></a>
                    </div>
                  </div>
                </template>
              </van-field>
            </van-form>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="title">
          <span>团员信息</span>
        </div>
        <div class="teamInformation">
          <div class="tips">
            <div><van-icon name="warning" />温馨提示</div>
            <p>
              请先下载模板，按要求如实填写，填好后上传，支持文件格式：xlsx。
            </p>
          </div>
          <div class="form_box">
            <van-form
              label-width="1.733rem"
              :colon="true"
              ref="infoFile"
              class="form"
            >
              <van-field
                name="信息采集"
                label="信息采集"
                :rules="[{ required: true, message: '信息采集不能为空' }]"
              >
                <template #input>
                  <div class="upload_box">
                    <van-uploader
                      accept=".xlsx,.xls,.xml"
                      v-model="infoFile"
                      :preview-image="false"
                      :after-read="afterRead"
                      :disabled="infoFile.length > 0"
                      v-show="infoFile.length <= 0"
                    >
                      <van-button icon="plus" size="small">上传文件</van-button>
                    </van-uploader>
                    <div
                      class="fileList"
                      v-for="(item, index) in infoFile"
                      :key="index"
                    >
                      <span>{{ item.file.name.split("/").at(-1) }}</span>
                      <van-icon name="cross" @click="infoFile = []" />
                    </div>
                    <div class="fileList">
                      <a
                        href="http://ticket.wzkjg.cn:9000/ticket-upload/2023/08/04/ebb19dfe7eaf4c66a2c3a92c4ee8f8ef.xlsx"
                        target="_blank"
                        ><span>团员信息采集表模板.xlsx</span
                        ><van-icon name="down"
                      /></a>
                    </div>
                  </div>
                </template>
              </van-field>
            </van-form>
          </div>
        </div>
      </div>
    </template>
    <van-button type="primary" class="btn_sty" @click="nextStep"
      >提交申请</van-button
    >
    <van-dialog
      v-model:show="show"
      title="确认提示"
      show-cancel-button
      confirmButtonText="提交"
      confirmButtonColor="#458aef"
      @confirm="confirm"
      class="confirm_tips"
    >
      <p>预约申请提交后无法修改，您确定要提交吗？</p>
    </van-dialog>
    <van-dialog
      v-model:show="show2"
      :showConfirmButton="false"
      class="appointment"
    >
      <template #title>
        <div class="dialog_tit">
          <van-icon name="checked" /><span>提交成功！</span>
        </div>
      </template>
      <p>您的预约申请已提交成功，请耐心等待工作人员审核！</p>
      <div class="gotIt_btn">
        <van-button type="primary" @click="$router.replace('/')"
          >知道了</van-button
        >
      </div>
    </van-dialog>
    <MyNotice ref="myNotice" />
    <van-popup
      class="commonly_popup"
      v-model:show="commonlyShow"
      position="right"
    >
      <CommonlyUsed
        :max="max"
        :ids="ids"
        :disableds="disableds"
        @personnel="personnel"
      />
    </van-popup>
  </div>
</template>
<script>
import MyNotice from "@/components/MyNotice.vue";
import CommonlyUsed from "./CommonlyUsed.vue";
import {
  getCommonConfig,
  ticketScheduleList,
  ticketTeam,
} from "@/api/Reservation";
import { upload } from "@/api/api";
import { contactList } from "@/api/CommonlyUsed";
export default {
  name: "TeamReservation",
  data() {
    return {
      active: 0,
      dateList: [],
      scheduleList: [],
      dateActive: null,
      sessionsActive: null,
      steppers: {},
      quantity: {},
      show: false,
      show2: false,
      infoFile: [],
      templateFile: [],
      list: [],
      list2: [],
      contactList: [],
      max: 0,
      ids: [],
      disableds: [],
      commonlyShow: false,
      commonlyActive: "",
      data: {},
      api: process.env.VUE_APP_BASE_API + "/profile",
    };
  },
  props: {
    clickRightNum: {
      type: Number,
      default: 0,
    },
  },
  computed: {},
  components: { MyNotice, CommonlyUsed },
  created() {
    this.getCommonConfig();
    this.getAppointment();
  },
  mounted() {},
  methods: {
    del(item, active) {
      this[active] = this[active].filter((item2) => item2.id !== item.id);
    },
    async personnel(ids) {
      let { data } = await contactList();
      this.contactList = data;
      let arr = [];
      ids.map((item) => {
        arr = arr.concat(this.contactList.filter((item2) => item2.id === item));
      });
      this[this.commonlyActive] = arr;
      this.commonlyShow = false;
    },
    addPersonnel(num, active, active2) {
      let ids = [];
      let ids2 = [];
      this.commonlyActive = active;
      this[active].map((item) => {
        ids.push(item.id);
      });
      this[active2].map((item) => {
        ids2.push(item.id);
      });
      this.disableds = ids2;
      this.ids = ids;
      this.max = num;
      this.commonlyShow = true;
    },
    //文件上传
    afterRead(file) {
      let imgFile = new FormData();
      imgFile.append("file", file.file);
      file.status = "uploading";
      file.message = "上传中...";
      upload(imgFile)
        .then((res) => {
          file.url = res.data.url;
          file.fileId = res.data.ossId;
          file.status = "done";
          file.message = "上传完成";
        })
        .catch(() => {
          file.status = "failed";
          file.message = "上传失败";
        });
    },
    //下一步
    async nextStep() {
      if (this.active === 0) {
        if (this.dateActive === null) {
          this.$notify({
            type: "danger",
            message: "请先选择日期",
          });
        } else if (this.sessionsActive === null) {
          this.$notify({
            type: "danger",
            message: "请先选择场次",
          });
        } else {
          let validate = true;
          if (!this.list.length) {
            this.$notify({
              type: "danger",
              message: "请添加团队联系人信息",
            });
            validate = false;
          }
          try {
            await this.$refs.infoFile.validate();
          } catch (error) {
            validate = false;
          }
          try {
            await this.$refs.templateFile.validate();
          } catch (error) {
            validate = false;
          }
          if (validate) {
            this.show = true;
          }
        }
      }
    },
    //时间
    async onDate(index) {
      this.dateActive = index;
      this.sessionsActive = null;
    },
    //选择场次
    async selectSession(index) {
      this.sessionsActive = index;
    },
    //确认提交
    async confirm() {
      let scheduleId =
        this.scheduleList[this.dateActive][this.sessionsActive].id;
      let { id } = this.list[0];
      console.log(this.infoFile[0]);
      let formData = {
        contactId: id,
        scheduleId,
        isTeamTicket: true,
        totalNum: this.quantity.td,
        contactsIds: this.list2,
        infoFileId: this.infoFile[0].fileId,
        promiseFileId: this.templateFile[0].fileId,
      };
      await ticketTeam(formData);
      this.active++;
      this.show2 = true;
    },
    //点击步骤的标题或图标
    clickStep(index) {
      if (index < this.active) {
        this.active = index;
      }
    },
    //查询配置
    async getCommonConfig() {
      let { data } = await getCommonConfig({ ticketType: 6 });
      this.steppers.td = {};
      let { teamMinLimit, teamMaxLimit } = data;
      this.steppers.td = {
        title: "团队人数限制" + teamMinLimit + "-" + teamMaxLimit + "人",
        min: teamMinLimit,
        max: teamMaxLimit,
      };
      this.data = data;
    },
    //预约详情信息
    async getAppointment() {
      let {
        data: { scheduleByDayMap, scheduleList },
      } = await ticketScheduleList({});
      let date = new Date();
      let time =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 >= 10 ? "" : "0") +
        (date.getMonth() + 1) +
        "-" +
        (date.getDate() >= 10 ? "" : "0") +
        date.getDate();
      const days = ["日", "一", "二", "三", "四", "五", "六"];
      scheduleByDayMap = scheduleByDayMap.filter(
        (item) => item.teamTicketIsDue === false
      );
      scheduleByDayMap.forEach((item) => {
        let weekDay = new Date(item.scheduleDate).getDay();
        item.title = time === item.scheduleDate ? "今天" : days[weekDay];
        let useDates = item.scheduleDate.split("-");
        item.date = useDates[1] + "/" + useDates[2];
        let arr = scheduleList.filter(
          (item2) => item.scheduleDate === item2.scheduleDate
        );
        this.scheduleList.push(arr);
      });
      this.dateList = scheduleByDayMap;
      console.log(this.scheduleList);
    },
  },
  watch: {
    //点击预约须知
    clickRightNum() {
      this.$refs.myNotice.init("团队", false, this.data.notice);
    },
  },
};
</script>
<style lang="scss" scoped>
.teamReservation {
  height: 100%;
  background: #f5f6fa;
  min-height: calc(100vh - 92px);
  padding-bottom: 46px;
  ::v-deep .van-sticky {
    background: #fff;
    width: 100%;
    height: 85px;
    display: flex;
    align-items: center;
    .van-steps {
      width: 100%;
      padding: 0 50px;
      .van-steps__items {
        .van-hairline {
          .van-step__circle-container,
          .van-step__line {
            top: 38px;
          }
          .van-step__title {
            font-size: 16px;
          }
          .van-step__circle-container {
            .van-icon {
              font-size: 16px;
            }
            .van-step__circle {
              width: 10px;
              height: 10px;
            }
          }
        }
        .van-step--horizontal:first-child {
          .van-step__title {
            margin-left: -20px;
          }
        }
        .van-step--horizontal:last-child {
          .van-step__title {
            margin-right: -20px;
          }
        }
      }
    }
  }
  .box {
    margin: 10px;
    background: #fff;
    border-radius: 5px;
    padding: 15px 20px;
    .title {
      padding-bottom: 10px;
      border-bottom: 1px solid #ececec;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: rgb(51, 51, 51);
      }
      .add_btn {
        font-size: 14px;
        font-weight: 400;
        color: #0b6cf9;
      }
    }
    .please_select {
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      margin-top: 10px;
    }
    .title_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .profile {
      margin-top: 10px;
      p {
        font-size: 14px;
        color: #666;
        line-height: 24px;
      }
    }
    .sessions {
      padding: 10px 5px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      border-bottom: 1px solid #ececec;
      > div {
        position: relative;
        width: 47%;
        height: 70px;
        font-size: 14px;
        color: #076cfa;
        text-align: center;
        border: 1px solid #076cfa;
        border-radius: 7px;
        margin: 6px 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        > img {
          position: absolute;
          width: 25px;
          height: 25px;
          right: 0;
          top: 0;
        }
      }
      .state {
        color: #999;
        border: 1px solid #999;
      }
      .sessionsActive {
        background: rgba(7, 108, 250, 0.1);
      }
      .tips {
        font-size: 16px;
      }
    }
    .quantity {
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      > div {
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        > p {
          color: #333;
          font-size: 14px;
        }
        > span {
          color: #999;
          font-size: 12px;
        }
        ::v-deep .van-stepper {
          height: 24px;
          line-height: 24px;
          .van-stepper__minus {
            color: #0b6cf9;
            border: 1px solid #0b6cf9;
          }
          .van-stepper__plus {
            color: #0b6cf9;
            background: #fff;
            border: 1px solid #0b6cf9;
          }
        }
      }
    }
    .quantity + .quantity {
      padding-top: 15px;
      border-top: 1px solid #ececec;
    }
    .teamInformation {
      margin: 10px 4px;
      .tips {
        background-color: #fefbf1;
        border: 1px solid #ffb500;
        border-radius: 3px;
        padding: 10px 14px;
        div {
          font-size: 15px;
          color: #f9871e;
          i {
            margin-right: 5px;
          }
        }
        p {
          margin: 10px 0;
          font-weight: 400;
          font-style: normal;
          font-size: 12px;
          color: #666666;
          line-height: 20px;
        }
      }
    }
    ::v-deep .form_box {
      background: #fdfdfd;
      border-radius: 5px;
      .item {
        border-bottom: 1px solid #dbdbdb;
        background-color: #fff;
        padding: 10px 20px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          display: block;
        }
        .right {
          width: 100%;
          padding: 0 10px;
          margin-left: 5px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .info {
            p {
              font-size: 13px;
              line-height: 20px;
            }
            .name {
              font-size: 15px;
              line-height: 24px;
            }
          }
        }
      }
      .form {
        .van-field__label {
          margin-right: 0;
        }
        .upload_box {
          width: 100%;
          .van-uploader {
            margin: 0;
          }
          .fileList {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #256fec;
            .van-icon-cross {
              color: #ec5515;
            }
            .van-icon-down {
              color: #256fec;
            }
            a {
              width: 100%;
              color: #256fec;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
        }
      }
    }
  }
  .date_box {
    padding: 20px 20px 10px;
    .dates {
      display: flex;
      overflow-x: auto;
      .date_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        > span {
          font-size: 14px;
          font-weight: 650;
        }
        > div {
          margin-top: 5px;
          border-radius: 50%;
          width: 50px;
          height: 30px;
          padding: 15px 5px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 12px;
            color: #fff;
          }
        }
      }
      > div + div {
        margin-left: 10px;
      }
    }
    .dates::-webkit-scrollbar {
      height: 0;
    }
  }
  .btn_sty {
    position: fixed;
    bottom: 0;
    width: 100%;
    line-height: 44px;
    height: 44px;
    font-weight: 650;
    font-size: 16px;
    color: #fff;
  }
  .confirm_tips {
    p {
      padding: 0 20px;
    }
  }
  ::v-deep .appointment {
    .van-dialog__header {
      padding: 15px 0;
      font-size: 16px;
      color: #333333;
      font-weight: 650;
      .dialog_tit {
        display: flex;
        justify-content: center;
        align-items: center;
        > i {
          color: #4bd863;
          font-size: 22px;
          margin-right: 10px;
        }
      }
    }
    .van-dialog__content {
      padding: 0 20px;
      .gotIt_btn {
        display: flex;
        justify-content: center;
        margin: 10px 0;
        .van-button {
          width: 80px;
          height: 30px;
          border-radius: 15px;
        }
      }
    }
  }
  ::v-deep .commonly_popup {
    width: 100vw;
    height: 100vh;
    overflow-y: hidden;
    .commonlyUsed {
      height: 100vh;
      .van-checkbox-group {
        margin-bottom: 60px;
      }
    }
  }
}
</style>
